import { render, staticRenderFns } from "./FeedbackCollaboration.vue?vue&type=template&id=c7c49fcc&"
import script from "./FeedbackCollaboration.vue?vue&type=script&lang=js&"
export * from "./FeedbackCollaboration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports